// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"bee1b4b8cd5fe9eb","5285":"1f1a45a276cc0578"}[chunkId] + ".css";
};